// extracted by mini-css-extract-plugin
export var book_cta = "BookCTA-module--book_cta--3wvgu";
export var book_cta_wrapper = "BookCTA-module--book_cta_wrapper--3tE0L";
export var book_menu = "BookCTA-module--book_menu--2e9oV";
export var open = "BookCTA-module--open--3GpdL";
export var doctolib = "BookCTA-module--doctolib--3kwBC";